import React from 'react';

export const PrintStyles = () => {
  // Print styles
  const getPageStyles = () => {
    return `@page { margin: 1.5em 1.5em 1.5em 1.5em !important; }
    
    
@media all {
  .page-break {
    display: none;
  }
}

@media print {
  html,
  body {
    height: initial !important;
    overflow: initial !important;
  }
}

@media print {
  .page-break {
    margin-top: 1rem;
    display: block;
    page-break-before: always;
    // page-break-after: always;
  }
    .no-break {
    page-break-inside: avoid;

        page-break-before: auto;
    page-break-after: auto;

  }
}`;
  };
  return <style>{getPageStyles()}</style>;
};
